export default __webpack_public_path__ + "static/media/step2.b8689f9d.svg";